import tw, {styled} from 'twin.macro'

const ShadowBox = styled.div(() => [
  tw`mt-6 rounded-lg shadow-lg py-4 px-6 bg-white`,
])

export default ShadowBox
